import React from 'react';
import isEmpty from 'lodash.isempty';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import styles from './LoginForm.module.css';
import { planKey } from '../../../service/PlanKey';

const Invitation = ({ variant = 'default' }) => {
  const subscriptionInvitationToken = useSelector(
    (state) => state.invitationToken.subscriptionInvitationData,
  );
  const tokeErrorMessage = useSelector((state) => state.invitationToken.tokeErrorMessage);

  const graveInvitation = useSelector((state) => state.grave.graveInvitationToken);
  return (
    <div>
      {!isEmpty(subscriptionInvitationToken) ? (
        <div className={styles['invitation-message']}>
          <FormattedMessage
            id="subscription_invitation_message"
            values={{
              subscription: planKey(subscriptionInvitationToken.subscription_key),
              name: subscriptionInvitationToken.invited_by,
            }}
          />
        </div>
      ) : null}
      {!isEmpty(tokeErrorMessage) ? (
        <div className={styles['invitation-error-message']}>{tokeErrorMessage}</div>
      ) : null}

      {!isEmpty(graveInvitation) ? (
        <div
          className={
            variant === 'register'
              ? styles.invitationInlineMessage
              : styles['invitation-message']
          }
        >
          <div>
            <FormattedMessage
              id="grave_invitation_message"
              values={{
                name: graveInvitation.inviting_user?.full_name || '',
                grave: graveInvitation.grave?.name || '',
              }}
            />
          </div>
          <div>
            <FormattedMessage id="grave_invitation_second_text" />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Invitation;
